import { fixationAllocations } from "./fixationAllocation";

export const fixationEmailContent = (fixation, format) => {
  const date = fixation.FixationDate?.split("T")[0] || "";
  return {
    subject: `Metal Price Fixation ${fixation.FixationID} - ${date}`,
    body: `Fixation ID: ${fixation.FixationID}\nDate: ${date}\nQuantity: ${fixation.Quantity} MT\nFixed price: ${fixation.Currency || "USD"} ${fixation.FixationValue ?? fixation.LMEPrice}\n${fixationAllocations(fixation).map(container => `${container.ContainerNo}: ${container.Quantity} MT`).join("\n")}\n\nPlease find the ${format === "pdf" ? "PDF" : "Excel"} fixation document attached.`
  };
};
